import React from 'react';
import { Table } from 'react-bootstrap';

export default class SimpleDataTable extends React.Component {

  componentDidMount() {
    if (this.props.refresh) {
      this.props.refresh();
    }
  }

  handleDelete(pk) {
    let r = confirm('確認刪除 ?');
    if (r === true) {
      this.props.deleteItem(pk);
    }
  }

  render() {
    let tableHeader = [];

    if (this.props.showDelete) {
      tableHeader.push((
        <td key='deleteIcon' style={{ width: 1 }}></td>
      ));
    }

    if (this.props.showEdit) {
      tableHeader.push((
        <td key='editIcon' style={{ width: 1 }}></td>
      ));
    }

    for (let fieldName in this.props.fields) {
      if (this.props.fields.hasOwnProperty(fieldName)) {
        tableHeader.push((
          <th key={fieldName}>{this.props.fields[fieldName]}</th>
        ));
      }
    }

    let tableRows = [];

    if (this.props.data) {

      //for (let i in this.props.data) {
      for (let i = 0; i < this.props.data.size; i++) {
        //let row = this.props.data[i];
        let row = this.props.data.get(i);
        let pkStr = i;  // default key
        let pk = {}; // primary key object
        if (this.props.keys) {
          for (let i = 0; i < this.props.keys.length; i++) {
            let keyField = this.props.keys[i];
            //pk[keyField] = row[keyField];
            pk[keyField] = row.get(keyField);
          }
          // primary key as a string
          pkStr = JSON.stringify(pk);
        }

        let rowObj = [];

        if (this.props.showDelete) {
          rowObj.push((
            <td key='deleteIcon' style={{ width: 1 }}>
              <span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442', cursor: 'pointer' }} onClick={(event) => {
                this.handleDelete(pk);
              }} />
            </td>
          ));
        }

        if (this.props.showEdit) {
          rowObj.push((
            <td key='editIcon' style={{ width: 1 }}>
              <span className="glyphicon glyphicon-pencil" style={{ marginRight: 10, cursor: 'pointer' }} onClick={(event) => {
                this.props.editItem(pk);
              }} />
            </td>
          ));
        }

        for (let fieldName in this.props.fields) {
          if (this.props.fields.hasOwnProperty(fieldName)) {
            rowObj.push((
              <td key={fieldName}>{row.get(fieldName)}</td>
            ));
          }
        }

        let stylePointer = {};
        if (this.props.onClick) {
          stylePointer = { cursor: 'pointer' }
        }

        tableRows.push((
          <tr key={pkStr} onClick={
            (event) => {
              if (this.props.onClick) {
                this.props.onClick(pk);
              }
            }
          } style={stylePointer}>
            {rowObj}
          </tr>
        ));
      }
    }

    return (
      <div>
        <Table bordered condensed hover>
          <thead>
            <tr>
              {tableHeader}
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/SimpleDataTable.jsx